import React, { useEffect, useState } from "react";
import YourIndividualVillaImages from "../components/YourProperty/IndividualVilla/YourIndividualVillaImages";
import YourIndividualVillaDetails from "../components/YourProperty/IndividualVilla/YourIndividualVillaDetails";
import YourIndividualVillaOverview from "../components/YourProperty/IndividualVilla/YourIndividualVillaOverview";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useLocation, useNavigate } from "react-router-dom";
import { investorApi } from "../api/api";
import DescriptionIcon from '@mui/icons-material/Description';
import {
  Box,
  useMediaQuery,
  useTheme,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
} from "@mui/material";
import YourPropertyDocuments from "../components/YourProperty/YourPropertyDocuments";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
const YourIndividualVillaScreen = () => {
  const theme = useTheme();
  const isTabletOrLaptop = useMediaQuery(theme.breakpoints.down("md"));
  const { state } = useLocation();
  const properties = state?.property;
  const navigate = useNavigate();
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchDetails = async () => {
      try {
        const response = await investorApi.getIndependentHouseById(properties.id);
        if (response.status === 200) {
          setPropertyData(response.data);
        }
      } catch (error) {
        console.error("API Error", error);
      } finally {
        setLoading(false);
      }
    };
    if (properties?.id) {
      fetchDetails();
    } else {
      setLoading(false);
    }
  }, [properties?.id]);
  const handleAddImage = () => {
    // Open image uploader or modal
    navigate("/AddVillaImages", { state: { propertyData } });
  };
  // const handleDeleteImage = () => {
  //   // Open confirm dialog or trigger delete
  //   alert("Delete Image clicked");
  // };
  const handleEditDetails = () => {
    // Open property detail form/modal
   
    navigate("/EditVillaDetails", { state: { propertyData } });
  };
  const actions = [
    {
      icon: <DescriptionIcon />,      // <-- Document icon here
      name: "Add Documents",
      onClick: () => {
        navigate("/addDocuments", { state: { propertyData: propertyData } });
      },
    },
    {
      icon: <AddPhotoAlternateIcon />,
      name: "Add Image",
      onClick: handleAddImage,
    },
    {
      icon:<PriceChangeIcon/>,
      name:"Price Update",
      onClick:()=>{
        navigate("/UpdatePropertyPrice",{
          state:{
            apartmentData:propertyData
          }
        })
      }
    },
    {
      icon: <EditNoteIcon />,
      name: "Edit Details",
      onClick: handleEditDetails,
    },
  ];

  return (
    <>
      {/* Main Content */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: isTabletOrLaptop ? "column" : "row",
          overflow: "hidden",
          padding: isTabletOrLaptop ? 1 : 2,
          boxSizing: "border-box",
        }}
      >
        {/* Left - Images */}
        <Box
          sx={{
            width: isTabletOrLaptop ? "100%" : "60%",
            pr: isTabletOrLaptop ? 0 : 2,
            mb: isTabletOrLaptop ? 2 : 0,
          }}
        >
          <Box
            sx={{
              height: "100%",
              borderRadius: 3,
              overflow: "hidden",
            }}
          >
            <YourIndividualVillaImages propertyId={properties.id} />
          </Box>
        </Box>
        {/* Right - Details */}
        <Box
          sx={{
            width: isTabletOrLaptop ? "100%" : "40%",
          }}
        >
          <Box
            sx={{
              height: "100%",
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              overflowY: "auto",
            }}
          >
            <YourIndividualVillaDetails propertyData={propertyData} />
          </Box>
        </Box>
      </Box>
      {/* Overview Section */}
      <YourIndividualVillaOverview propertyData={propertyData} />
      <Box sx={{margin:4}}>
      <YourPropertyDocuments data={propertyData} />
      </Box>
      {/* SpeedDial FAB */}
      <SpeedDial
        ariaLabel="Property actions"
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          zIndex: 1000,
        }}
        icon={<SpeedDialIcon />}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
          />
        ))}
      </SpeedDial>
    </>
  );
};
export default YourIndividualVillaScreen;